/**
 * Route-aware suggested questions for the help agent's opening view. The
 * heading above them is fixed copy (`empty.title`); only the rows vary.
 *
 * Static i18n keys (namespace `help_agent`) rather than a backend fetch so
 * the suggestions are instantly localized in all five languages and render
 * with zero latency. The backend's route manifest carries its own copy of
 * these questions for agent grounding only — keep the two in spirit-sync
 * when adding a surface.
 */

export interface SuggestedQuestionsEntry {
  /** Longest matching prefix wins. */
  prefix: string
  questionKeys: string[]
}

export const SUGGESTED_QUESTIONS: SuggestedQuestionsEntry[] = [
  {
    prefix: '/data-catalog',
    questionKeys: [
      'suggestions.data_catalog.q1',
      'suggestions.data_catalog.q2',
      'suggestions.data_catalog.q3',
    ],
  },
  {
    prefix: '/intelligent-board',
    questionKeys: ['suggestions.board.q1', 'suggestions.board.q2', 'suggestions.board.q3'],
  },
  {
    prefix: '/board',
    questionKeys: ['suggestions.board.q1', 'suggestions.board.q2', 'suggestions.board.q3'],
  },
  {
    prefix: '/workflow',
    questionKeys: ['suggestions.workflow.q1', 'suggestions.workflow.q2', 'suggestions.workflow.q3'],
  },
  {
    prefix: '/digital-coworker',
    questionKeys: [
      'suggestions.digital_coworker.q1',
      'suggestions.digital_coworker.q2',
      'suggestions.digital_coworker.q3',
    ],
  },
]

export const FALLBACK_SUGGESTIONS: SuggestedQuestionsEntry = {
  prefix: '/',
  questionKeys: ['suggestions.generic.q1', 'suggestions.generic.q2', 'suggestions.generic.q3'],
}

export function getSuggestionsForRoute(pathname: string): SuggestedQuestionsEntry {
  let best: SuggestedQuestionsEntry | undefined
  for (const entry of SUGGESTED_QUESTIONS) {
    if (pathname.startsWith(entry.prefix) && (!best || entry.prefix.length > best.prefix.length)) {
      best = entry
    }
  }
  return best ?? FALLBACK_SUGGESTIONS
}
